// Constants
import { ExperimentConfiguration } from '../experiments.types'

import EXPERIMENTS from './experiments'

// Types

const EXPERIMENT_CONFIG_LIST: ExperimentConfiguration[] = [
  {
    name: 'show-similar-exp',
    date: '2024-07-03',
    buckets: [
      { name: 'control', ratio: 100 },
      { name: 'show', ratio: 0 },
    ],
  },
  {
    name: 'vday-cutoff-message',
    date: '2024-07-03',
    buckets: [
      { name: 'control', ratio: 100 },
      { name: 'showDate', ratio: 0 },
      { name: 'showArrival', ratio: 0 },
    ],
  },
  {
    name: 'cart-hurry-msg',
    date: '2024-07-03',
    buckets: [
      { name: 'control', ratio: 0 },
      { name: 'show', ratio: 100 },
    ],
  },
  {
    name: 'hybrid-mte',
    date: '2024-02-06',
    buckets: [
      { name: 'show', ratio: 50 },
      { name: 'control', ratio: 50 },
    ],
  },
  {
    name: 'category-and-departments-filter',
    date: '2024-05-30',
    buckets: [
      { name: 'show', ratio: 100 },
      { name: 'control', ratio: 0 },
    ],
  },
  {
    name: 'pdp-rec-modules',
    date: '2024-03-05',
    buckets: [
      { name: 'show', ratio: 50 },
      { name: 'control', ratio: 50 },
    ],
  },
  {
    name: 'pdp-new-tab',
    date: '2024-03-05',
    buckets: [
      { name: 'control', ratio: 100 },
      { name: 'show', ratio: 0 },
    ],
  },
  {
    name: 'default-cart-recommendation',
    date: '2024-04-30',
    buckets: [
      { name: 'show', ratio: 100 },
      { name: 'control', ratio: 0 },
    ],
  },
  {
    name: 'housekeeing-award',
    date: '2024-07-03',
    buckets: [
      { name: 'show', ratio: 0 },
      { name: 'control', ratio: 100 },
    ],
  },
  {
    name: 'free-tote',
    date: '2024-03-31',
    buckets: [
      { name: 'show', ratio: 0 },
      { name: 'control', ratio: 100 },
    ],
  },
  {
    name: 'subcollection-sort',
    date: '2024-06-07',
    buckets: [
      { name: 'revenue', ratio: 0 },
      { name: 'control', ratio: 100 },
      { name: 'newClp', ratio: 0 },
      { name: 'bestSeller', ratio: 0 },
    ],
  },
  {
    name: 'sticky-atc-a',
    date: '2023-05-02',
    buckets: [
      { name: 'control', ratio: 100 },
      { name: 'show', ratio: 0 },
    ],
  },
  {
    name: 'mini-pdp',
    date: '2024-04-05',
    buckets: [
      { name: 'control', ratio: 100 },
      { name: 'testA', ratio: 0 },
      { name: 'testB', ratio: 0 },
    ],
  },
  {
    name: 'all-dept-shop',
    date: '2024-24-07',
    buckets: [
      { name: 'control', ratio: 0 },
      { name: 'text', ratio: 100 },
      { name: 'image', ratio: 0 },
    ],
  },
  {
    name: 'bestseller-product-diversity',
    date: '2024-07-03',
    buckets: [
      { name: 'control', ratio: 100 },
      { name: 'show', ratio: 0 },
    ],
  },
  {
    name: 'pdp-comparison-section',
    date: '2024-07-03',
    buckets: [
      { name: 'control', ratio: 50 },
      { name: 'show', ratio: 50 },
    ],
  },
  {
    name: EXPERIMENTS.OFF_SHOPIFY_CHECKOUT.experimentName,
    date: '2024-10-04',
    ignoreBucketRebucketingHash: '25-sep-2024',
    buckets: [
      { name: EXPERIMENTS.OFF_SHOPIFY_CHECKOUT.bucketNames.show, ratio: 100 },
      { name: EXPERIMENTS.OFF_SHOPIFY_CHECKOUT.bucketNames.baseline, ratio: 0 },
    ],
  },
  {
    name: EXPERIMENTS.CHECKOUT_CARD_POPUP.experimentName,
    date: '2024-08-13',
    buckets: [
      { name: EXPERIMENTS.CHECKOUT_CARD_POPUP.bucketNames.show, ratio: 0 },
      { name: EXPERIMENTS.CHECKOUT_CARD_POPUP.bucketNames.control, ratio: 100 },
    ],
  },
  {
    name: EXPERIMENTS.REVIEW_HIGHLIGHTS_MOBILE.experimentName,
    date: '2024-05-28',
    buckets: [
      { name: EXPERIMENTS.REVIEW_HIGHLIGHTS_MOBILE.bucketNames.show, ratio: 50 },
      { name: EXPERIMENTS.REVIEW_HIGHLIGHTS_MOBILE.bucketNames.control, ratio: 50 },
    ],
  },
  {
    name: EXPERIMENTS.REWARD_CREDIT_ON_CARTPAGE.experimentName,
    date: '2024-07-05',
    buckets: [
      { name: EXPERIMENTS.REWARD_CREDIT_ON_CARTPAGE.bucketNames.show, ratio: 50 },
      { name: EXPERIMENTS.REWARD_CREDIT_ON_CARTPAGE.bucketNames.control, ratio: 50 },
    ],
  },
  {
    name: EXPERIMENTS.CREDIT_TAGS_ON_PRODUCT_CARD.experimentName,
    date: '2024-08-06',
    buckets: [
      { name: EXPERIMENTS.CREDIT_TAGS_ON_PRODUCT_CARD.bucketNames.show, ratio: 50 },
      { name: EXPERIMENTS.CREDIT_TAGS_ON_PRODUCT_CARD.bucketNames.control, ratio: 50 },
    ],
  },
  {
    name: EXPERIMENTS.EXPAND_NEW_AND_NOTEWORTHY.experimentName,
    date: '2024-08-14',
    buckets: [
      { name: EXPERIMENTS.EXPAND_NEW_AND_NOTEWORTHY.bucketNames.show, ratio: 50 },
      { name: EXPERIMENTS.EXPAND_NEW_AND_NOTEWORTHY.bucketNames.control, ratio: 50 },
    ],
  },
  {
    name: EXPERIMENTS.NEW_LONG_FORM_MODULES.experimentName,
    date: '2024-06-08',
    buckets: [
      { name: EXPERIMENTS.NEW_LONG_FORM_MODULES.bucketNames.show, ratio: 50 },
      { name: EXPERIMENTS.NEW_LONG_FORM_MODULES.bucketNames.control, ratio: 50 },
    ],
  },
  {
    name: EXPERIMENTS.SHOW_ATC_ON_MOBILE.experimentName,
    date: '2024-08-23',
    buckets: [
      { name: EXPERIMENTS.SHOW_ATC_ON_MOBILE.bucketNames.show, ratio: 50 },
      { name: EXPERIMENTS.SHOW_ATC_ON_MOBILE.bucketNames.control, ratio: 50 },
    ],
  },
  {
    name: EXPERIMENTS.UGC_VIDEO_ON_PDP_IMAGE_CAROUSEL.experimentName,
    date: '2024-10-22',
    buckets: [
      { name: EXPERIMENTS.UGC_VIDEO_ON_PDP_IMAGE_CAROUSEL.bucketNames.variantA, ratio: 50 },
      { name: EXPERIMENTS.UGC_VIDEO_ON_PDP_IMAGE_CAROUSEL.bucketNames.control, ratio: 50 },
    ],
  },
]

Object.freeze(EXPERIMENT_CONFIG_LIST)

export default EXPERIMENT_CONFIG_LIST
